import { Controller } from "@hotwired/stimulus";
import * as common from "@/javascripts/common.js";

// Connects to data-controller="promoters--events--cancel_reserves"
export default class extends Controller {
  static targets = [
    "inquiryEmail",
    "inquiryPhone",
    "inquiryUrl",
    "cancelDate",
    "cancelHour",
    "cancelMinute",
    "checkBox",
    "testMailSubmit",
  ];
  static outlets = ["radio"];

  // 問い合わせ方法変更
  changeInquiryMethod(event) {
    const method = event.currentTarget.value;
    this.toggleInquiryTargets(method);
    const inquiryMethodRadio = this.radioOutlets.find((outlet) => outlet.element.id === "inquiry-method-radio");
    inquiryMethodRadio.toggle();
  }

  // 問い合わせ先入力欄のdisabled切り替え
  toggleInquiryTargets(method) {
    common.toggleDisabled(this.inquiryEmailTarget, method === "email");
    common.toggleDisabled(this.inquiryPhoneTarget, method === "phone");
    common.toggleDisabled(this.inquiryUrlTarget, method === "web");
  }

  // 中止予約の有無変更
  changeIsReserved(event) {
    const isReserved = event.currentTarget.value;
    this.toggleIsReserved(isReserved);
    const isReservedRadio = this.radioOutlets.find((outlet) => outlet.element.id === "is-reserved-radio");
    isReservedRadio.toggle();
  }

  // 中止日時入力欄のdisabled切り替え
  toggleIsReserved(isReserved) {
    common.toggleDisabled(this.cancelDateTarget, isReserved === "true");
    common.toggleDisabled(this.cancelHourTarget, isReserved === "true");
    common.toggleDisabled(this.cancelMinuteTarget, isReserved === "true");
  }

  // テストメールの送信ボタンのdisabled切り替え
  toggleTestMailSubmitButton() {
    // 1つも選択されていない場合はdisabledにする
    const checkBox_checked = this.checkBoxTargets.every((checkBox) => !checkBox.checked);
    this.testMailSubmitTarget.disabled = checkBox_checked;
    this.testMailSubmitTarget.setAttribute("aria-disabled", checkBox_checked);
  }
}
